import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {Container} from './styles';
import Settings from '../../assets/emojis/settings/chart-increasing.png';
import User from '../../assets/emojis/aval/user.png';
import Arrow from '../../assets/emojis/aval/arrow.png';
import ArrowLeft from '../../assets/emojis/aval/arrow-left.png';
import api from '../../services/api'
import moment from 'moment'

moment.locale('pt-br')

const ItensPorPagina = 5

const Relatorio = () => {
    
    const [tipo, setTipo] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [vendas, setVendas] = useState([])
    const [searchDate, setSearchDate] = useState(1)
    const [label, setLabel] = useState('de hoje')
    const [quantidadeVendas, setQuantidadeVendas] = useState(0)
    

    let indiceInicial = (currentPage - 1) * ItensPorPagina
    let indiceFinal = currentPage * ItensPorPagina
    let itensDaPagina = vendas.length ? vendas[0].vendas.slice(indiceInicial, indiceFinal) : []
    // let totalPaginas = Math.ceil(vendas.length ? vendas[0].vendas.length / ItensPorPagina : 0)
    let totalPaginas = Math.max(Math.ceil(vendas.length ? vendas[0].vendas.length / ItensPorPagina : 0), 1);


    const getRelatorioVendas = async (searchDate) => {

        const token = await localStorage.getItem('@jwt')

        api.post('/api/vendas', { search_date: searchDate } ,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => {
            
            if(res.data.data === true){

                if(searchDate === 0){
                    setLabel('de ontem')
                }

                if(searchDate === 7){
                    setLabel('dos últimos 7 dias')
                }

                if(searchDate === 30){
                    setLabel('dos últimos 30 dias')
                }

                if(searchDate === 60){
                    setLabel('dos últimos 60 dias')
                }

                setCurrentPage(1)
                setQuantidadeVendas(res.data.result[0].quantidade_vendas)
                setVendas(res.data.result)
            }

        }).catch(async e => {
            console.log(e)
        })
    }

    useEffect(() => {
        getRelatorioVendas(1)
    }, [])

    const paginarProxima = () => {
        if (currentPage < Math.ceil(vendas[0].vendas.length / ItensPorPagina)) {
          setCurrentPage(currentPage + 1)
        }
    }

    const paginarAnterior = () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
    }

    return(
        <Container>
        
        <div className="div-pai">
            <div className="div-rota"> 

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/'}>
                <span
                    className="rotas" >
                    Início
                </span>
            </Link>

            <span className="rotas"> {'>'} </span>

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/minhas-vendas'}>
                <span>
                    Minhas Vendas
                </span>
            </Link>

            </div>

            <div className="titulo">
                <img alt="" className="emoji" src={Settings} />
            
                <h1>Minhas vendas</h1>

                <h5>Consulte suas vendas e fique por dentro da operação da sua loja.</h5>
            </div>

            <hr className="linha"/>

            <div className="periodo">
                <h2>Selecione o período</h2>
                <span className='subtexto'>Quer consultar as vendas de qual período?</span>

                <div className="options">
                    <div 
                        style={{ cursor: 'pointer'}}
                        onClick={() => {
                        setTipo(1) 
                        setSearchDate(1)
                        getRelatorioVendas(1)}
                    }
                        
                        className={tipo === 1 ? 'option-selected' : 'option'}>
                        <span>Hoje</span>
                    </div>
                    <div 
                        style={{ cursor: 'pointer'}}
                        onClick={() => {
                        setTipo(2) 
                        setSearchDate(0)
                        getRelatorioVendas(0)}
                    }
                        className={tipo === 2 ? 'option-selected' : 'option'}>
                        <span>Ontem</span>
                    </div>
                    <div 
                        style={{ cursor: 'pointer'}}
                        onClick={() => {
                        setTipo(3) 
                        setSearchDate(7)
                        getRelatorioVendas(7)}
                    }
                        className={tipo === 3 ? 'option-selected' : 'option'}>
                        <span>Últimos 7 dias</span>
                    </div>
                    <div 
                        style={{ cursor: 'pointer'}}
                        onClick={() => {
                        setTipo(4) 
                        setSearchDate(30)
                        getRelatorioVendas(30)}
                    }
                        className={tipo === 4 ? 'option-selected' : 'option'}>
                        <span>Últimos 30 dias</span>
                    </div>
                    <div 
                        style={{ cursor: 'pointer'}}
                        onClick={() => {
                        setTipo(5) 
                        setSearchDate(60)
                        getRelatorioVendas(60)}
                    }
                        className={tipo === 5 ? 'option-selected' : 'option'}>
                        <span>Últimos 60 dias</span>
                    </div>
                </div>
            </div>
            
            <hr className="linha"/>
            <div className="vendas">
                <h2>Vendas {label}</h2>
            </div>

            {vendas.length &&
            <div className='row1'>
                <div className='borda'>
                    <div className='nota'>
                        <span>{vendas[0].quantidade_vendas}</span>
                        <div className='star'>
                            <span>Quantidade das vendas concluídas</span> 
                        </div>
                    </div>
                </div>

                <div className='borda'>
                    <div className='nota'>
                        <span>{Number(vendas[0].total_vendas).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span>
                        <div className='star'>
                            <span>Total das vendas</span>             
                        </div>
                    </div>
                </div>
            </div>
            }

            <div className='paginacao'>
                <span>Exibindo</span>
                <span className="paginas"> {itensDaPagina.length} </span>
                <span> resultados de</span>
                <span className="paginas"> {quantidadeVendas} </span>
            </div>
            
            {vendas.length && itensDaPagina.map(item => 
                <div className='borda3' key={item.id}>
                    <div className='conteudo'>
                        <img alt="" className="user" src={User} />
                            <div className='coluna'>
                                <span className='userName'>{item.nome} ({Number(item.valor_venda).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})})</span>
                                    <div className='row-mobile'>
                                        <span className='subtexto1'>{item.chave_pedido} ・ </span>
                                        <span className='subtexto1'>{moment(item.dia_venda).format('DD/MM/YYYY')} às {item.hora_venda}</span>
                                            <Link to={`/minhas-vendas/detalhes/${item.chave_pedido}`} target="_blank"
                                                style={{ cursor: 'pointer' }}>
                                                <button className="salvar-branco">
                                                    ver detalhes
                                                </button>
                                            </Link>
                                    </div>
                                    <div>
                                        <Link to={`/minhas-vendas/detalhes/${item.chave_pedido}`} target="_blank" style={{ cursor: 'pointer' , textDecoration: 'none' }}>
                                            <button className="salvar-branco-celular">
                                                ver detalhes
                                            </button>
                                        </Link>
                                    </div>
                            </div>
                    </div>                        
                </div>
            )}

            <div className="paginacaoEnd">
                {totalPaginas > 1 && currentPage > 1 && (
                    <button
                        className="button"
                        style={{ cursor: 'pointer' , marginLeft: '-113px' }}
                        onClick={paginarAnterior}
                        >
                        <img alt="" className="arrow" src={ArrowLeft} />
                        Voltar
                    </button>
                )}
                <span className="paginas1">{currentPage}</span>
                <span style={{ marginRight: 27 }}> de </span>
                <span className="paginas1"> {totalPaginas}</span>
                {totalPaginas > 1 && currentPage < totalPaginas && (
                    <button
                        className="button1"
                        style={{ cursor: 'pointer' }}
                        onClick={paginarProxima}
                        >
                        Seguinte
                        <img alt="" className="arrow" src={Arrow} />
                    </button>
                )}
            </div>
        </div>
        </Container>
    )
}

export default Relatorio
